import { createBrowserHistory } from 'history';
import TvingLogModule from '../tving-log-module/TvingLogModule';
/**
 * useNavigate 특성상 navigate(-1)이 의도하지 않은 곳으로 이동할 수 있기 때문에,
 * 자체적인 스택을 구현하여 예상한 범위 내에서 페이지를 이동하도록 합니다.
 */
var TvingNavigator = /** @class */ (function () {
    function TvingNavigator(defaultUrl) {
        if (defaultUrl === void 0) { defaultUrl = '/'; }
        this.history = createBrowserHistory();
        this.defaultUrl = defaultUrl;
        this.pages = [
            {
                path: window.location.pathname,
            },
        ];
    }
    TvingNavigator.prototype.setDefaultUrl = function (url) {
        this.defaultUrl = url;
    };
    TvingNavigator.prototype.getBackPagePath = function () {
        var _a;
        return ((_a = this.pages[this.pages.length - 2]) === null || _a === void 0 ? void 0 : _a.path) || this.defaultUrl;
    };
    TvingNavigator.prototype.reset = function (path, state) {
        TvingLogModule.debug('page reset', path);
        this.pages = [
            {
                path: path || this.defaultUrl,
                state: state,
            },
        ];
        this.history.replace(path || this.defaultUrl, state);
    };
    TvingNavigator.prototype.push = function (path, state) {
        TvingLogModule.debug('page push', path);
        var lastPage = this.pages[this.pages.length - 1];
        if (lastPage && lastPage.path === path) {
            // 같은 path 연속 push 시 return;
            return;
        }
        this.pages.push({
            path: path,
            state: state,
        });
        this.history.push(path, state);
    };
    TvingNavigator.prototype.replace = function (path, state) {
        TvingLogModule.debug('page replace', path);
        this.pages.pop();
        this.pages.push({
            path: path,
            state: state,
        });
        this.history.replace(path, state);
    };
    TvingNavigator.prototype.back = function (count, isClearState) {
        var _this = this;
        if (count === void 0) { count = 1; }
        if (isClearState === void 0) { isClearState = false; }
        TvingLogModule.debug('page back');
        Array.from({ length: count }).forEach(function () {
            _this.pages.pop();
        });
        if (this.pages.length > 0) {
            var lastPage = this.pages[this.pages.length - 1];
            if (this.pages.length > 0) {
                if (isClearState) {
                    lastPage.state = {};
                }
                this.history.replace(lastPage.path, lastPage.state);
            }
            else {
                this.history.replace(this.defaultUrl);
            }
        }
        else {
            this.history.replace(this.defaultUrl);
        }
    };
    TvingNavigator.prototype.getHistory = function () {
        return this.history;
    };
    TvingNavigator.prototype.getPages = function () {
        return this.pages;
    };
    return TvingNavigator;
}());
export default TvingNavigator;
